import React from "react";
const GuidePage = (props) => {
  return (
    <>
      <section>
        <div className="container">
          {/* <div className="line"></div> */}
          <img
            className="img-full"
            src="assets/img/Title-bar-3.png"
            alt="line-bt"
          />
          <p className="note-guide">
            Cùng gửi lời chúc đến người bạn yêu quý...
          </p>
          <div className="guide">
            <ul>
              <li>
                <div className="content-step">
                  <div className="step">Bước 1</div>
                  <p>Quét mã QR trên sticker</p>
                </div>
              </li>
              <li>
                <div className="content-step">
                  <div className="step">Bước 2</div>
                  <p>Chọn bài nhạc nền để phát khi người nhận đọc lời chúc</p>
                </div>
              </li>
              <li>
                <div className="content-step">
                  <div className="step">Bước 3</div>
                  <p>Nhập lời chúc gửi đến người bạn yêu quý</p>
                </div>
              </li>
              <li>
                <div className="content-step">
                  <div className="step">Bước 4</div>
                  <p>Chọn khung lời chúc theo mẫu có sẵn</p>
                </div>
              </li>
              <li>
                <div className="content-step">
                  <div className="step">Bước 5</div>
                  <p>
                    Lưu bản nháp để chỉnh sửa sau hoặc Xác nhận để hoàn thành
                    lời chúc
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};
export default GuidePage;
